import { IoCalendarOutline } from "react-icons/io5";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import { TopBar } from "../components/topbar";
import { useNavigate } from "react-router-dom";
import { AddAnnouncement } from "../components/addAnnouncement";

// Group announcements by month-year
function groupByMonth(data) {
    return data.reduce((acc, ann) => {
        const date = new Date(ann.date)
        const monthYear = date.toLocaleString("default", { month: "long", year: "numeric" })
        if (!acc[monthYear]) acc[monthYear] = []
        acc[monthYear].push(ann)
        return acc
    }, {})
}

export default function Announcements() {
    const {userProfile, logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [announcements, setAnnouncements] = useState([]);
    const navigate = useNavigate();
    const [pageLoading, setPageLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        console.log('cook', cookies);
        getData();
    }, [])

    async function getData() {
        setPageLoading(true)
        try {
            const response = await axios.get(base_url + '/announcement.php', {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    memberno: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            if (response.data.status) {
                setAnnouncements(response.data.data.announcements);
            } else {

            }
            setPageLoading(false)
        } catch (error) {
            setPageLoading(false)
        }
    }

    // const announcements = [
    //     {
    //         id: "1",
    //         title: "Annual General Meeting",
    //         content: "The AGM will be held on September 15th, 2025 at the Main Hall.",
    //         date: "2025-09-10",
    //     },
    //     {
    //         id: "2",
    //         title: "Club Renovation Notice",
    //         content: "Swimming pool will be closed for maintenance from October 1st to October 7th.",
    //         date: "2025-08-20",
    //     },
    //     {
    //         id: "3",
    //         title: "Monthly Tennis Tournament",
    //         content: "Join us for the monthly tennis tournament on September 25th. Registration closes Sept 20th.",
    //         date: "2025-09-05",
    //     },
    // ]

    const sortedAnnouncements = [...announcements].sort(
        (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
    )

    const grouped = groupByMonth(sortedAnnouncements)

    return (
        <div className="">
        {pageLoading && (
        <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
            <GridLoader
                color={'#000080'}
                loading={true}
                size={20}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </div>
        )}
        {showModal && 
            <AddAnnouncement
                setShowModal={setShowModal}
                getData={getData}
            />
        }
        <TopBar title={'Club Announcements'} />
        {/* <h2 className="text-2xl text-[#000080] font-bold mb-6">Club Announcements</h2> */}
        <div className="flex flex-row items-center justify-end px-5">
            {/* <h3 className="font-semibold mb-2">Events Calendar</h3> */}
            <div className="text-center space-y-3 pb-4">
                <button onClick={() => {setShowModal(true) }} className="bg-[#000080] text-[#fff] rounded-[5px] py-2 px-4">Add New Announcement</button>
            </div>
        </div>
        <div className="px-6">
        {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"> */}
            {Object.entries(grouped).map(([month, anns]) => (
            <div key={month} className="mb-10">
                <h3 className="text-xl font-semibold text-[#7ace90] mb-4">{month}</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {anns.map((announcement) => (
                    <div key={announcement.id} className="shadow-md p-4 rounded-2xl hover:shadow-lg transition">
                        <div>
                            <div className="text-lg pb-2">{announcement.title}</div>
                            <div className="flex items-center gap-2 text-sm text-gray-500 pb-3">
                                <IoCalendarOutline className="w-4 h-4 text-blue-500" />
                                {new Date(announcement.date).toDateString()}
                            </div>
                            </div>
                            <div>
                            <p className="text-gray-700">{announcement.message}</p>
                        </div>
                    </div>
                    ))}
                </div>
            </div>
            ))}
        </div>
        {/* </div> */}
        </div>
    )
}
